module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    attrs: {
      "label": _vm.label,
      "prop": _vm.attr.columnName
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.placeholder
    },
    model: {
      value: (_vm.updateFieldValue),
      callback: function($$v) {
        _vm.updateFieldValue = $$v
      },
      expression: "updateFieldValue"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-86b2c8f6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/sgs/SgsRenderInputFilterText.vue
// module id = 946
// module chunks = 2